import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import GridList, {GridListTile, GridListTileBar} from 'material-ui/GridList'
import IconButton from 'material-ui/IconButton'
import IconKeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft'
import IconKeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight'

const SPACING = 30

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    margin: '0 -24px',
  },
  gridList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  gridTile: {
    borderRadius: 2,
  },
  titleBar: {
    background: 'rgba(0,0,0,0)',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  title: {
    textAlign: 'center',
    fontSize: '1.5rem',
  },
})

const CategoryListHorizontal = ({classes, categories, search, selectCategory, deselectCategory}) => {
  const list = categories && categories.length > 0 ? categories[0] : null
  let listLength = 0
  let anySelected = false
  if (list) {
    listLength = list ? list.size : 0
    const array = list.toArray()
    for (let i = 0; i < array.length; i++) {
      if (array[i].get('Selected') === true) {
        anySelected = true
        break
      }
    }
  }
  return (
    <div className={classes.root}>
      <GridList
        cols={2.5} spacing={SPACING}
        className={classes.gridList}
        component={Ul}
      >
        {list === null ? <div/> : list.toArray().map((category, index) => (
          <GridListTile
            key={category.get('ID')}
            classes={{
              tile: classes.gridTile,
            }}
            style={{
              maxWidth: 400,
              minWidth: 300,
              paddingTop: 0,
              paddingRight: index === listLength - 1 ? 0 : SPACING / 2,
              paddingBottom: 0,
              paddingLeft: index === 0 ? 0 : SPACING / 2,
              opacity: anySelected === false ? 1 : category.get('Selected') === true ? 1 : 0.5,
            }}
            onClick={() => {
              if (category.get('Selected') === true) {
                deselectCategory(category.get('ID'))
              } else {
                selectCategory(category.get('ID'), true)
              }
              search()
            }}
          >
            <img src={category.get('Img')} alt={category.get('Description')}/>
            <GridListTileBar
              title={category.get('Description')}
              classes={{
                root: classes.titleBar,
                title: classes.title,
              }}
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  )
}

CategoryListHorizontal.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectCategory: PropTypes.func.isRequired,
  deselectCategory: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
}

export default withStyles(styles, {withTheme: true})(CategoryListHorizontal)

class Ul extends React.Component {

  styles = {
    container: {
      position: 'relative',
      width: 'calc(100% - 80px)',
      margin: '0 auto',
    },
    arrowLeft: {
      position: 'absolute',
      left: -36,
      top: '50%',
      height: 36,
      width: 36,
      padding: 5,
      transform: 'translateY(-50%)',
      zIndex: '1',
      backgroundColor: '#fff',
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    arrowRight: {
      position: 'absolute',
      right: -36,
      top: '50%',
      height: 36,
      width: 36,
      padding: 5,
      transform: 'translateY(-50%)',
      zIndex: '1',
      backgroundColor: '#fff',
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
  }

  el = {}

  handleArrowClick = dir => {
    if (this.el) this.el.scrollLeft = this.el.scrollLeft + 150 * dir
  }

  componentWillReceiveProps(props) {
    if (this.el) this.centerOnDate(props.indexSelected)
  }

  centerOnDate = indexSelected => {
    if (indexSelected && indexSelected !== -1) {
      this.el.scrollLeft = 50 * indexSelected - 100
    }
  }

  render() {
    const {children, indexSelected, ...other} = this.props //indexSelected triggers a DOM error in ul
    return (
      <div style={this.styles.container}>
        <IconButton style={this.styles.arrowLeft} onClick={() => this.handleArrowClick(-1)}>
          <IconKeyboardArrowLeft/>
        </IconButton>
        <ul {...other} ref={input => { this.el = input }}>{children}</ul>
        <IconButton style={this.styles.arrowRight} onClick={() => this.handleArrowClick(1)}>
          <IconKeyboardArrowRight/>
        </IconButton>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/CategoryListHorizontal.js